import { Component, Input, OnInit } from '@angular/core';
import { ColumnSortModel } from '../tableSortModel';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-column-header[sortModel]',
  templateUrl: './column-header.component.html',
  imports: [NgClass, TranslatePipe]
})
export class ColumnHeaderComponent implements OnInit {
  @Input()
  sortModel: ColumnSortModel<any>;

  @Input()
  columnName: String;

  constructor() {}

  ngOnInit(): void {}
}
